import React from 'react';
import TreasuryTable from './TreasuryOverviewTransactionTable';

const TreasuryTransactions = () => {
    return (
        <div className=''>
            <h1 className='px-4 pt-[32px] lg:px-0 lg:pt-0 text-[20px] font-medium leading-[30px] text-ebony'>
                Transactions
            </h1>

            <div className='mt-[32px] view-add-transactions'>
                <TreasuryTable />
            </div>
        </div>
    );
};

export default TreasuryTransactions;
